<template>
  <div class="rp-pagination">
    <small class="text-muted">
      Showing {{ (start + 1).toLocaleString('en-US') }}–{{ end.toLocaleString('en-US') }} of {{ total.toLocaleString('en-US') }}
    </small>
    <ul class="pagination pagination-sm mb-0">
      <li class="page-item" :class="{ disabled: page === 1 }">
        <button type="button" class="page-link" @click="$emit('go', page - 1)"><i class="ti ti-chevron-left"></i></button>
      </li>
      <li v-for="(number, index) in pages" :key="index" class="page-item"
          :class="{ active: number === page, disabled: number === '…' }">
        <button type="button" class="page-link" @click="$emit('go', number)">{{ number }}</button>
      </li>
      <li class="page-item" :class="{ disabled: page === pageCount }">
        <button type="button" class="page-link" @click="$emit('go', page + 1)"><i class="ti ti-chevron-right"></i></button>
      </li>
    </ul>
  </div>
</template>

<script>
/** Pager under the inventory report tables; the paging state lives in inventoryReportMixin. */
export default {
  name: 'ReportPagination',
  props: {
    page: { type: Number, required: true },
    pageCount: { type: Number, required: true },
    pages: { type: Array, required: true },
    start: { type: Number, required: true },
    end: { type: Number, required: true },
    total: { type: Number, required: true },
  },
  emits: ['go'],
};
</script>

<style scoped src="./inventoryReport.css"></style>
